type EmptyValue = null | undefined;

export const isEmpty = (val: unknown): boolean =>
  val === null || val === undefined;

/**
 * Returns the display value or "N/A" if null/undefined/empty.
 * Used across all single-flight-dashboard cards for consistent null handling.
 *
 */

export const formatDisplayValue = (
  val: string | number | EmptyValue
): string => {
  if (isEmpty(val) || val === "") {
    return "—";
  }
  return String(val);
};

export const formatHeaderDisplayValue = (
  val: string | number | EmptyValue
): string => {
  if (isEmpty(val)) {
    return "";
  }
  return String(val);
};
